import { GlButton, GlLink, GlPopover } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'FlowUnavailableButton',
    components: {
        GlButton,
        GlLink,
        GlPopover
    },
    // Bound by hand so the explicit `disabled` below beats a caller's `:disabled`
    // under Vue 3, where fallthrough attrs would otherwise win.
    inheritAttrs: false,
    props: {
        message: {
            type: String,
            required: true
        },
        helpPath: {
            type: String,
            required: false,
            default: ''
        },
        size: {
            type: String,
            default: 'small',
            required: false
        },
        variant: {
            type: String,
            default: 'default',
            required: false
        },
        category: {
            type: String,
            default: 'primary',
            required: false
        }
    }
};
